export default __webpack_public_path__ + "static/ProviderCopyToEpic-e7128e58e34162beaecf47c463e10345.svg";